'use client'

import type { Data } from '@repo/strapi'
import AppLink from '@/components/elementary/AppLink'
import { BasicImage } from '@/components/page-builder/components/BasicImage'
import { createTrackingContext } from '@/lib/analytics/analytics'
import { cn } from '@/lib/styles'
import type { PricingCtaSection } from '@/types/api/pricing.types'

export const PlanCallToAction = ({
	button,
	className,
	linkClassName,
	planTitle,
	section,
}: {
	button?: Data.Component<'shared.pricing-plan-detail'>['button'] | null
	className?: string
	linkClassName?: string
	planTitle?: string
	section?: PricingCtaSection
}) => {
	return (
		<div className={cn('px-3.75', className)}>
			{button?.link?.href && (
				<AppLink
					variant="primary"
					inverted
					size="large"
					href={button?.link?.href}
					openExternalInNewTab={button?.link?.newTab ?? false}
					className={cn('w-full shrink-0', linkClassName)}
					trackingContext={createTrackingContext({
						plan: planTitle,
						planSection: section,
					})}
				>
					{button?.icon ? (
						<div className="relative size-6 shrink-0">
							<BasicImage fill loading="lazy" component={button?.icon} className="object-contain" />
						</div>
					) : null}
					{button?.link?.label}
				</AppLink>
			)}
		</div>
	)
}
